import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/common/atoms/Button';
import { Col, Flex } from '@/ui/layout';
import styled from 'styled-components';
import { BREAKPOINTS } from '@/ui/layout';

export const AdminApproveRejectButtons = ({
  adminView,
  statusSettings,
  onReject,
  onApprove,
  rejectDisabled = false,
  variant = 'inline'
}) => {
  const { t } = useTranslation();

  if (!adminView || !statusSettings || (!onReject && !onApprove)) {
    return null;
  }

  const Wrapper = variant === 'float' ? FloatButtons : InlineButtons;

  return (
    <Wrapper>
      {onReject && (
        <Col $auto>
          <Button
            text={statusSettings.isRejected ? t('Rejected') : t('Reject')}
            onClick={onReject}
            disabled={!statusSettings.allowReject || rejectDisabled}
          />
        </Col>
      )}
      {onApprove && (
        <Col $auto>
          <Button
            text={statusSettings.isApproved ? t('Approved') : t('Approve')}
            onClick={onApprove}
            disabled={!statusSettings.allowApprove}
            $paddingX={'18'}
          />
        </Col>
      )}
    </Wrapper>
  );
};

const FloatButtons = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  gap: 16px;

  @media (max-width: ${BREAKPOINTS.lg}px) {
    top: -40px;
    gap: 8px;
  }
`;

const InlineButtons = styled(Flex)`
  gap: 8px;
`;
